import { forwardRef, type Ref, type SVGProps } from "react";

function SvgCheckmarkFilled(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 17" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8 1.833a6.667 6.667 0 1 0 0 13.333A6.667 6.667 0 0 0 8 1.833m2.387 5.317a.5.5 0 0 0-.774-.634l-2.65 3.24-.943-.943a.5.5 0 0 0-.707.707l1.333 1.333a.5.5 0 0 0 .74-.037z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCheckmarkFilled);
export default ForwardRef;
